import { createContext, useContext } from "react";
import { DataTableContextValue } from "./types";

export const DataTableContext = createContext<DataTableContextValue<any> | null>(null);

export function useDataTableContext<TRow>(): DataTableContextValue<TRow> {
  const context = useContext(DataTableContext);
  if (!context) {
    throw new Error(
      "useDataTableContext must be used within a DataTable component"
    );
  }
  return context as DataTableContextValue<TRow>;
}
